let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d7sp9")).then(() => parcelRequire('4Au5p'));